module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nivagation"
  }, [_c('span', {
    staticClass: "iconfont pre",
    on: {
      "click": _vm.prev
    }
  }, [_vm._v("")]), _c('span', [_vm._v(" " + _vm._s(_vm.current) + " / " + _vm._s(_vm.total))]), _c('span', {
    staticClass: "iconfont next",
    on: {
      "click": _vm.next
    }
  }, [_vm._v(" ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a28861cc","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/page.vue
// module id = 515
// module chunks = 1